import { httpClient, getAgencyId, getApplicationHeaders } from "@utils";
import { ExclusionReasonCodeValidationMessageDto } from "@api-types/locks/ExclusionReasonCodeValidationMessageDto";
import { LockResponseDto } from "@api-types/locks/LockResponseDto";
import { SelfExclusionInfoDto } from "@api-types/locks/SelfExclusionInfoDto";
export default class TwAgencyUserLocksApiService {
	static getRequestHeaders = () => {
		const appHeaders = getApplicationHeaders();
		appHeaders["Content-Type" as keyof HeadersInit] = "application/json";
		return appHeaders;
	};

	private static get baseUrl(): string {
		return `${WEBPACK_BASE_ADDRESS}platform/tw-agency-user-locks`;
	}

	// always returns OK, in case of error isSuccess prop will be false
	static oasisTemporaryLock(): Promise<LockResponseDto> {
		return httpClient.put(
			`${this.baseUrl}/oasis-temporary-lock/${getAgencyId()}`,
			null,
			this.getRequestHeaders(),
			{ responseType: "json" }
		);
	}

	// in case of invalid lock: string message, exclusion reason code validation messages, lock response object with isSuccess false
	static async createOasisSelfTemporaryLock(
		requestModel: SelfExclusionInfoDto
	): Promise<
		LockResponseDto | ExclusionReasonCodeValidationMessageDto[] | string
	> {
		return await httpClient.put(
			`${this.baseUrl}/oasis-self-temporary-lock-with-password`,
			JSON.stringify(requestModel),
			this.getRequestHeaders(),
			{ responseType: "json" }
		);
	}
}
